<template lang="pug">
v-flex(xs12)
  v-card.pix-card(flat)
    div.pa-4
      div.expande-horizontal.align-center.mb-4
        v-avatar(size="34" color="#ecfdf5").mr-3
          v-icon(color="#059669") mdi-qrcode-scan
        div
          div.form-title Pix
          div.form-subtitle O cadastro avanca somente apos a confirmacao do pagamento

      v-alert(type="info" dense outlined class="pix-alert")
        | Vamos gerar a cobranca Pix no Asaas e validar o pagamento no mesmo fluxo.

      div.pix-steps.mb-4
        div.step-item
          v-icon.small.mr-2(color="#059669") mdi-check-circle-outline
          span Confira seus dados acima
        div.step-item
          v-icon.small.mr-2(color="#059669") mdi-check-circle-outline
          span Finalize o pagamento no ambiente Pix
        div.step-item
          v-icon.small.mr-2(color="#059669") mdi-check-circle-outline
          span O acesso sera liberado apos confirmacao

      v-btn.payment-btn.fonte.text-none(block large dark @click="submitPix" :color="$theme.secondary")
        | Finalizar com Pix
        v-icon.ml-2(size="18") mdi-arrow-right
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  computed: {
    ...mapGetters(["get_checkout"])
  },
  methods: {
    ...mapActions(["checkout"]),
    hasValidPayer() {
      const payer = this.get_checkout.payer || {};
      return Boolean(
        payer.name &&
          payer.email &&
          payer.cpf_cnpj &&
          payer.phone_prefix &&
          payer.phone
      );
    },
    submitPix() {
      if (!this.hasValidPayer()) {
        this.$store.dispatch("createGlobalMessage", {
          timeout: 6000,
          type: "warning",
          message: "Preencha primeiro seus dados pessoais antes de pagar."
        });
        return;
      }

      this.checkout();
    }
  }
};
</script>

<style scoped>
.pix-card {
  margin-top: 16px;
  border: 1px solid #e9ecf5;
  border-radius: 14px;
  background: #fff;
}

.form-title {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.form-subtitle {
  font-size: 12px;
  color: #64748b;
}

.pix-alert {
  border-radius: 10px;
  background: #f8fafc;
}

.pix-steps {
  display: grid;
  gap: 8px;
}

.step-item {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #334155;
}

.payment-btn {
  border-radius: 12px;
}
</style>
